<template>
  <div v-if="adapter" class="h-full flex flex-col">
    <div class="w-full flex-grow overflow-auto pl-2 pb-2">
      <DataAdapterConfiguration :adapter="adapter" :verifying="verifying" ref="configuration" @update="payload = $event" @verify="verify" />
      <div class="mt-4 flex justify-end max-w-900">
        <PillButton :text="$t('save')" primary @click="save" :loading="saving" />
      </div>
      <div class="mt-6 max-w-900">
        <div class="text-18 font-500 mb-2">{{ $t('projects.danger_zone') }}</div>
        <div class="border border-solid border-alert border-opacity-50 rounded-8">
          <div class="flex justify-between items-center p-4">
            <div>
              <div class="font-600">{{ $t('projects.data_adapters.delete_this') }}</div>
              <div>{{ $t('projects.data_adapters.delete_warning') }}</div>
            </div>
            <PillButton :text="$t('projects.data_adapters.delete_this')" error @click="openDeleteModal"></PillButton>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import DataAdapterConfiguration from '@/components/data-adapters/DataAdapterConfiguration.vue';
import { apiPostProjectDataAdapterVerify } from '@/helpers/api';
import DeleteModal from '../../../modals/DeleteModal.vue';

export default {
  name: 'DataAdapterSettings',
  components: { DataAdapterConfiguration },
  props: {
    adapter: Object,
  },
  data() {
    return {
      saving: false,
      verifying: false,
      payload: null,
    };
  },
  computed: {
    ...mapState(['availableDataAdapters']),
    projectId() {
      return this.$route.params.projectId;
    },
    adapterType() {
      return this.$route.params.dataAdapter;
    },
    getName() {
      return this.adapter?.payload?.name || this.availableDataAdapters?.[this.adapter?.type]?.name || '';
    },
  },
  methods: {
    ...mapActions(['updateProjectDataAdapter', 'deleteProjectDataAdapter', 'fetchProjectDataAdapter', 'showToastMessage']),
    openDeleteModal() {
      this.$showModal(DeleteModal, {
        subtitle: this.$t('projects.data_adapters.confirm_delete', { adapter: this.getName }),
        info: null,
        onConfirm: async () => {
          await this.deleteProjectDataAdapter({ project_id: this.projectId, adapter_type: this.adapterType });
          this.$router.push({ name: 'project-integration-hub', params: { projectId: this.projectId } });
        },
      });
    },
    async save() {
      const valid = this.$refs.configuration.validate();
      if (!valid.valid) return;
      this.saving = true;
      await this.updateProjectDataAdapter({ project_id: this.projectId, adapter_type: this.adapterType, ...this.payload });
      await this.fetchProjectDataAdapter({ projectId: this.projectId, adapterType: this.adapterType });
      this.saving = false;
    },
    async verify() {
      this.verifying = true;
      const response = await apiPostProjectDataAdapterVerify({ project_id: this.projectId, adapter_type: this.adapterType });
      this.verifying = false;
      if (response.status === 200) {
        await this.fetchProjectDataAdapter({ projectId: this.projectId, adapterType: this.adapterType });
        this.showToastMessage({ message: response.data.connected ? 'Connection verified' : response.data.error || 'Connection failed', type: response.data.connected ? 'success' : 'error' });
      } else {
        this.showToastMessage({ message: response.data?.message || 'Connection failed', type: 'error' });
      }
    },
  },
};
</script>
